import { AppPagePaths } from "App/routes/paths";

import { AgentDesktopPaths } from "./paths";

export const AGENT_DESKTOP_PAGE_DESCRIPTIONS = {
    [AppPagePaths.agentDesktop]: "Main agent workspace for handling customer interactions and tasks.",
    [`${AppPagePaths.agentDesktop}/${AgentDesktopPaths.contacts[0]}`]:
        "Contact management interface for viewing and interacting with customer profiles.",
} as const;
